import styles from './AdvtVote.module.css';
import { useGetDescriptionParams } from './useGetDescriptionParams';

export const AdvtVote = ({ questionImgUrl, advancedSettings }) => {
  const { fio, position, report, thema } =
    useGetDescriptionParams(advancedSettings);

  return (
    <div className={styles.wrapper}>
      <div className={styles.nameWrapper}>
        {questionImgUrl && (
          <div className={styles.questionImgUrl}>
            <img src={questionImgUrl} alt="" />
          </div>
        )}

        <div className={styles.nameBlock}>
          {fio && <div className={styles.name}>{fio}</div>}

          {position && <div className={styles.position}>{position}</div>}
        </div>
      </div>

      {report && <div className={styles.doklad}>«{report}»</div>}

      {thema && <div className={styles.title}>Тема: «{thema}»</div>}
    </div>
  );
};
